/* eslint-disable */
import $ from 'jquery';
import _ from 'underscore';
import PageContext from '@bingads-webui-static-legacy/page-context';
import * as Toast from '@bingads-webui-component-legacy/toast/index';
import LocalStorage from '@bingads-webui-component-legacy/storage/localStorage';
import CopyPasteModel from '@bingads-webui-static-legacy/bulk-edit/model/copypaste/copyPaste';
import CopyPasteView from '@bingads-webui-static-legacy/bulk-edit/view/copypaste/copyPaste';
import FilterHelper from '@bingads-webui-static-legacy/bulk-edit/view/filterHelper';
import gridHelper from '@bingads-webui-static-legacy/shared/view/gridHelper';
import ViewModel from '@bingads-webui-static-legacy/bulk-edit/viewmodel/copypaste/copyPaste';
var i18n = window.globalLegacyI18n.get('module/extension/requirejs/i18n!global');
var osd = window.osd;
var isCampaignsTab = function () {
  return PageContext.CurrentTabId === 'Campaign' || PageContext.CurrentTabId === 'Campaigns';
};
var isAdGroupsTab = function () {
  return PageContext.CurrentCampaign && (PageContext.CurrentTabId === 'AdGroup' || PageContext.CurrentTabId === 'Adgroups');
};
var isKeywordsTab = function () {
  return PageContext.CurrentAdGroup && PageContext.CurrentTabId === 'Keywords';
};
var isAdsTab = function () {
  return PageContext.CurrentAdGroup && PageContext.CurrentTabId === 'Ads';
};
var isAssetGroupsTab = function () {
  return PageContext.CurrentCampaign && PageContext.CurrentTabId === 'Assetgroups';
}
var getClipboardName = function () {
  return ('clipboard-').concat(PageContext.CurrentAccount.Id);
};
var getDateRangeQueryArgs = function () {
  var dateRange;
  if (!!osd && !!osd.ui && !!osd.ui.Controls && !!osd.ui.Controls.DateRangeFilter && _.isFunction(osd.ui.Controls.DateRangeFilter.getParsedDateRange)) {
    dateRange = osd.ui.Controls.DateRangeFilter.getParsedDateRange();
  } else {
    dateRange = window.App && window.App.state ? window.App.state.get('$daterange') : null;
  }
  if (dateRange) {
    var startdate = (dateRange.start || dateRange.RangeStartDate).toISOString(), enddate = (dateRange.end || dateRange.RangeEndDate).toISOString();
    return 'startdate=' + startdate + '&enddate=' + enddate;
  }
  return '';
};
var tabIdToClipboardType = {
  Campaign: 'campaign',
  Campaigns: 'campaign',
  AdGroup: 'adgroup',
  Adgroups: 'adgroup',
  Ads: 'ad',
  Keywords: 'keyword',
  Assetgroups: 'assetgroup',
};
var tabs = {
  'ad': {
    validate: isAdsTab,
    strings: {
      wrongTab: i18n.getString('BulkEdit_PasteAds_WrongTab'),
      wrongType: i18n.getString('BulkEdit_PasteAds_WrongType'),
      copyOneSuccess_OldUI: i18n.getString('BulkEdit_CopyOneAd_Success_OldUI'),
      copyNSuccess_OldUI: i18n.getString('BulkEdit_CopyNAds_Success_OldUI'),
      copyOneSuccess_NewUI: i18n.getString('BulkEdit_CopyOneAd_Success_NewUI'),
      copyNSuccess_NewUI: i18n.getString('BulkEdit_CopyNAds_Success_NewUI')
    },
    filters: function (grid) {
      return FilterHelper.getIdFilter(grid, 'Ad');
    }
  },
  'keyword': {
    validate: isKeywordsTab,
    strings: {
      wrongTab: i18n.getString('BulkEdit_PasteKeywords_WrongTab'),
      wrongType: i18n.getString('BulkEdit_PasteKeywords_WrongType'),
      copyOneSuccess_OldUI: i18n.getString('BulkEdit_CopyOneKeyword_Success_OldUI'),
      copyNSuccess_OldUI: i18n.getString('BulkEdit_CopyNKeywords_Success_OldUI'),
      copyOneSuccess_NewUI: i18n.getString('BulkEdit_CopyOneKeyword_Success_NewUI'),
      copyNSuccess_NewUI: i18n.getString('BulkEdit_CopyNKeywords_Success_NewUI')
    },
    filters: function (grid) {
      return FilterHelper.getIdFilter(grid, 'Keyword');
    }
  },
  'campaign': {
    validate: isCampaignsTab,
    strings: {
      wrongTab: i18n.getString('BulkEdit_PasteCampaigns_WrongTab'),
      wrongType: i18n.getString('BulkEdit_PasteCampaigns_WrongType'),
      copyOneSuccess_OldUI: i18n.getString('BulkEdit_CopyOneCampaign_Success_OldUI'),
      copyNSuccess_OldUI: i18n.getString('BulkEdit_CopyNCampaigns_Success_OldUI'),
      copyOneSuccess_NewUI: i18n.getString('BulkEdit_CopyOneCampaign_Success_NewUI'),
      copyNSuccess_NewUI: i18n.getString('BulkEdit_CopyNCampaigns_Success_NewUI')
    },
    filters: function (grid) {
      return FilterHelper.getIdFilter(grid, 'Campaign');
    }
  },
  'adgroup': {
    validate: isAdGroupsTab,
    strings: {
      wrongTab: i18n.getString('BulkEdit_PasteAdGroups_WrongTab'),
      wrongType: i18n.getString('BulkEdit_PasteAdGroups_WrongType'),
      copyOneSuccess_OldUI: i18n.getString('BulkEdit_CopyOneAdGroup_Success_OldUI'),
      copyNSuccess_OldUI: i18n.getString('BulkEdit_CopyNAdGroups_Success_OldUI'),
      copyOneSuccess_NewUI: i18n.getString('BulkEdit_CopyOneAdGroup_Success_NewUI'),
      copyNSuccess_NewUI: i18n.getString('BulkEdit_CopyNAdGroups_Success_NewUI')
    },
    filters: function (grid) {
      return FilterHelper.getIdFilter(grid, 'AdGroup');
    }
  },
  'assetgroup': {
    validate: isAssetGroupsTab,
    strings: {
      wrongTab: i18n.getString('BulkEdit_PasteAssetGroups_WrongTab'),
      wrongType: i18n.getString('BulkEdit_PasteAssetGroups_WrongType'),
      copyOneSuccess_OldUI: i18n.getString('BulkEdit_CopyOneAssetGroup_Success_OldUI'),
      copyNSuccess_OldUI: i18n.getString('BulkEdit_CopyNAssetGroups_Success_OldUI'),
      copyOneSuccess_NewUI: i18n.getString('BulkEdit_CopyOneAssetGroup_Success_NewUI'),
      copyNSuccess_NewUI: i18n.getString('BulkEdit_CopyNAssetGroups_Success_NewUI')
    },
    filters: function (grid) {
      return FilterHelper.getIdFilter(grid, 'AssetGroup');
    }
  }
};
var validateTab = function (type) {
  var isValid = false;
  var tab = tabs[type];
  var expectedType = tabIdToClipboardType[PageContext.CurrentTabId];
  if (expectedType && expectedType !== type) {
    alert(tabs[expectedType].strings.wrongType);
  } else if (tab) {
    isValid = tab.validate();
    if (!isValid) {
      alert(tab.strings.wrongTab);
    }
  } else {
    if (PageContext.CurrentTabId === 'Campaign') {
      alert(i18n.getString('BulkEdit_PasteCampaigns_NothingCopied'));
    } else if (PageContext.CurrentTabId === 'AdGroup') {
      alert(i18n.getString('BulkEdit_PasteAdGroups_NothingCopied'));
    } else if (PageContext.CurrentTabId === 'Assetgroups') {
      alert(i18n.getString('BulkEdit_PasteAssetGroups_NothingCopied'));
    } else {
      alert(i18n.getString('BulkEdit_PasteAdsOrKeywords_NothingCopied'));
    }
  }
  return isValid;
};
ViewModel.validateTab = validateTab;
export default {
  validateTab: validateTab,
  copy: function (type, grid) {
    var copyPerfMarker;
    if (grid.perfMarker) {
      copyPerfMarker = grid.perfMarker.createChild('pgrid-Copy-action');
      copyPerfMarker.willInit();
    }
    var selectedItemsLength = gridHelper.getSelectedRowsCount(grid);
    if (!type || !grid || selectedItemsLength === 0) {
      return;
    }
    if (type === 'campaign') {
      var selectedRows = gridHelper.getSelectedRows(grid);
      for (var i = 0; i < selectedRows.length; i++) {
        if (selectedRows[i].CampaignType === 'Smart') {
          Toast.showError(i18n.getString('CopyPasteSmartCampaigns_ErrorMessage'));
          LocalStorage.set(getClipboardName(), null);
          return;
        }
      }
    }
    var count = 0;
    var filters = null;
    if (gridHelper.isCrossPageAllSelected(grid)) {
      if (type === 'campaign' || type === 'adgroup') {
        Toast.showError(i18n.getString('CopyPasteCampaignAdGroupCrossPage_ErrorMessage'));
        LocalStorage.set(getClipboardName(), null);
        return;
      }
      count = gridHelper.getTotalRowsCount(grid);
      filters = FilterHelper.getFiltersIncludeWaterfall(grid);
    } else {
      count = selectedItemsLength;
      filters = tabs[type] && tabs[type].filters(grid);
    }
    LocalStorage.set(getClipboardName(), {
      'type': type,
      'count': count,
      'campaignId': PageContext.CurrentCampaign ? PageContext.CurrentCampaign.Id : -1,
      'adGroupId': PageContext.CurrentAdGroup ? PageContext.CurrentAdGroup.Id : -1,
      'dateRange': getDateRangeQueryArgs(),
      'filters': filters ? $.extend(true, {}, filters) : null
    });
    if (tabs[type]) {
      if ((type === 'campaign' || type === 'adgroup') && !PageContext.Permissions.IsCampaignAdGroupCopyPasteEnabled) {
        return;
      }
      Toast.showSuccess(count === 1 ? tabs[type].strings.copyOneSuccess_NewUI : _.template(tabs[type].strings.copyNSuccess_NewUI)({
        count: count
      }));
    }
    if (copyPerfMarker) {
      copyPerfMarker.done();
    }
  },
  paste: function (grid) {
    var pastePerfMarker;
    if (grid.perfMarker) {
      pastePerfMarker = grid.perfMarker.createChild('pgrid-Paste-action');
      pastePerfMarker.willInit();
    }
    var clipboard = LocalStorage.get(getClipboardName());
    if (clipboard) {
      if (!this.validateTab(clipboard.type)) {
        return;
      }
      switch (clipboard.type) {
        case 'ad':
        case 'keyword':
        case 'campaign':
        case 'adgroup':
        case 'assetgroup':
          var view = new CopyPasteView({
            perfMarker: pastePerfMarker,
            model: new CopyPasteModel({
              content: clipboard
            }),
            grid: grid,
            onOperationSuccess: function () {
              Toast.showSuccess(i18n.getString('BulkEdit_Notification_Success'));
              grid.gridView.refresh(false);
            },
            onOperationFailure: function () {
              if (clipboard.type === 'campaign' || clipboard.type === 'adgroup') {
                Toast.showError(i18n.getString('CampaignAdGroupCopyPaste_CompletedWithErrorsText_NewUI'));
              } else {
                Toast.showError(i18n.getString('BulkEdit_Notification_Failure'));
              }
            }
          });
          view.render();
          return view;
          break;
        default:
          alert(i18n.getString('BulkEdit_PasteAdsOrKeywords_NothingCopied'));
          break;
      }
    } else {
      if (isCampaignsTab()) {
        alert(i18n.getString('BulkEdit_PasteCampaigns_NothingCopied'));
      } else if (PageContext.CurrentTabId === 'AdGroup' || PageContext.CurrentTabId === 'Adgroups') {
        alert(i18n.getString('BulkEdit_PasteAdGroups_NothingCopied'));
      } else if (PageContext.CurrentTabId === 'Assetgroups') {
        alert(i18n.getString('BulkEdit_PasteAssetGroups_NothingCopied'));
      } else {
        alert(i18n.getString('BulkEdit_PasteAdsOrKeywords_NothingCopied'));
      }
    }
  }
};

